import { useQueries } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { tradingKeys } from '../tradingQueryKeys'
import { getMarketProperty } from '../tradingEndpoints'
import { parseMarketProperty } from '../tradingParser'
import type { MarketProperty } from '../../types/tradingTypes'

// Several properties at once, keyed by id — the orders grid reads location
// and spec chips the order rows don't carry. Same keys + fetcher as
// useMarketPropertyQuery, so the cache is shared with drawers and the
// property page. A property that no longer trades (404) just drops out.
export function useMarketPropertiesQuery(propertyIds: MaybeRefOrGetter<string[]>) {
  return useQueries({
    queries: () =>
      toValue(propertyIds).map((id) => ({
        queryKey: tradingKeys.property(id),
        queryFn: () => getMarketProperty(id).then(parseMarketProperty),
        retry: false,
      })),
    combine: (results) => {
      const byId = new Map<string, MarketProperty>()
      for (const result of results) {
        if (result.data) byId.set(result.data.id, result.data)
      }
      return {
        byId,
        isLoading: results.some((result) => result.isLoading),
      }
    },
  })
}
